import React from "react";
import "../util/ArrayExtensions";
import { Stack } from "@mui/material";

export default function Breakable({ texts, style }: { texts: String[]; style?: React.CSSProperties }) {
  return (
    <Stack
      style={{
        display: "inline-block",
        wordBreak: "keep-all",
      }}
    >
      {texts.map((text, i) => (
        <span key={i} style={{ display: "inline-block", ...style }}>
          {text}
        </span>
      ))}
    </Stack>
  );
}
